module.exports = __webpack_public_path__ + "img/top.66b4c33c.jpg";